import React, { useState } from "react";
import { Box, Container } from "@mui/system";
import { Button, Fade, Typography } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import LottieAnimation from "../LottieAnimation";
import VideoPlayer from "../VideoPlayer";
import CustomModal from "../CustomModal";

const RiskwiseBanner = ({ banner, loading }) => {

    const mediaOne = banner?.media_one;
    const mediaTwo = banner?.media_two;

    const popUpVideo = banner?.pop_up_video;

    // const isVideoOne = mediaOne?.match(/\.(mp4|mov|avi|wmv)$/) != null;
    // const isVideoTwo = mediaTwo?.match(/\.(mp4|mov|avi|wmv)$/) != null;

    const medium = useMediaQuery('(max-width:1020px)');

    const [watchVideo, setWatchVideo] = useState(false);
    const handleClose = () => {
        setWatchVideo(false);
    }

    const [isPlaying, setIsPlaying] = useState(true);
    const handlePlay = () => {
        // setIsPlaying(true)
        document.querySelector('video').play()
    }
    const [isMuted, setIsMuted] = useState(true);
    const handleMute = () => {
        setIsMuted(true)
    }


    return (
        <>
            {loading ?
                <Box
                    sx={{
                        width: "100%",
                        height: "520px",
                        background: "linear-gradient(90deg, rgba(13,96,168,1) 33%, rgba(0,0,0,0) 100%)",
                    }}
                />
                : banner ?
                    <>
                        <Fade in={true} timeout={1000}>
                            <Box
                                sx={{
                                    backgroundImage: `url(${banner?.background_image})`,
                                    position: "relative",
                                    padding: "6rem 0 6rem 0",
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    minHeight: "520px",
                                    display: "flex",
                                    overflow: "hidden",
                                }}
                            >
                                <Container maxWidth="xl"
                                    sx={{
                                        position: "relative",
                                        display: "flex",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: medium ? "100%" : "45%",
                                        }}
                                    >
                                        <Typography
                                            variant="h1"
                                            sx={{
                                                lineHeight: "1.167",
                                                letterSpacing: "0em",
                                                color: "#ffffff",
                                                fontSize: "3.2rem",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {banner?.heading}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: "1.2rem",
                                                color: "#ffffff",
                                            }}
                                        >
                                            {banner?.description}
                                        </Typography>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                marginTop: "2rem",
                                                alignItems: "baseline",
                                            }}
                                        >
                                            <Button
                                                component={RouterLink}
                                                to="/contact/"
                                                sx={{
                                                    color: '#ffffff',
                                                    fontSize: '1rem',
                                                    backgroundColor: "#E9531C",
                                                    borderRadius: '50px',
                                                    fontWeight: '600',
                                                    padding: '0.5rem 1rem',
                                                    marginTop: '30px',
                                                    marginBottom: '25px',
                                                    '&:hover': {
                                                        backgroundColor: '#265DA5',
                                                    },
                                                }}
                                            >
                                                Book A Demo
                                            </Button>
                                            {/* <Button
                                                sx={{
                                                    marginLeft: "20px",
                                                    color: "#ffffff",
                                                    border: "2px solid #ffffff",
                                                    borderRadius: "30px",
                                                    padding: "0.5rem 1rem",
                                                    fontSize: "1rem",
                                                    position: "relative",
                                                    transition: "all 0.2s ease-in-out",
                                                    overflow: "hidden",
                                                    fontWeight: "600",
                                                    zIndex: "1",
                                                    "&::after": {
                                                        content: "''",
                                                        position: "absolute",
                                                        zIndex: "-1",
                                                        transition: "all 0.2s ease-in-out",
                                                        width: "100%",
                                                        height: "0%",
                                                        top: "0",
                                                        left: "0",
                                                        backgroundColor: "rgba(255,114,28,0.7)",
                                                    },
                                                    "&:hover": {
                                                        "&::after": {
                                                            height: "100%",
                                                        },
                                                    },
                                                }}
                                                onClick={() => setWatchVideo(true)}
                                            >
                                                Watch a Video
                                            </Button> */}
                                        </Box>
                                    </Box>

                                    {!medium ?
                                        <Box
                                            sx={{
                                                width: "50%",
                                                position: "relative",
                                                // maxWidth: "600px",
                                                ml: '5%',
                                            }}
                                        >

                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: '100%'
                                                }}>
                                                <LottieAnimation />
                                            </div>

                                            {/* {isVideoOne ?
                                        <video
                                            autoPlay
                                            muted
                                            loop
                                            style={{
                                                position: "absolute",
                                                right: "300px",
                                                bottom: "-70px",
                                                width: "auto",
                                                height: "auto",
                                                zIndex: "1",
                                                maxWidth: "200px",
                                            }}
                                        >
                                            <source src={mediaOne} type="video/mp4" />
                                        </video>
                                    :
                                        <img
                                            src={mediaOne}
                                            alt=""
                                            style={{
                                                position: "absolute",
                                                right: "300px",
                                                bottom: "-70px",
                                                width: "auto",
                                                height: "auto",
                                                zIndex: "1",
                                                maxWidth: "200px",
                                            }}
                                        />
                                    }
                                    {isVideoTwo ?
                                        <video
                                            autoPlay
                                            muted
                                            loop
                                            style={{
                                                position: "absolute",
                                                right: "-210px",
                                                top: "-60px",
                                                width: "auto",
                                                height: "auto",
                                                maxWidth: "656px",
                                            }}
                                        >
                                            <source src={mediaTwo} type="video/mp4" />
                                        </video>
                                    :
                                        <img
                                            src={mediaTwo}
                                            alt=""
                                            style={{
                                                position: "absolute",
                                                right: "-210px",
                                                top: "-60px",
                                                width: "auto",
                                                height: "auto",
                                                maxWidth: "656px",
                                            }}
                                        />
                                    } */}
                                        </Box>
                                        : null}
                                </Container>
                            </Box>
                        </Fade>

                        {watchVideo && popUpVideo && (
                            <CustomModal
                                open={watchVideo}
                                handleClose={handleClose}
                                title={`Riskwise Management Software`}
                            >
                                <Box
                                    sx={{
                                        width: '100%',
                                        p: 2
                                    }}>

                                    <VideoPlayer
                                        handleClose={handleClose}
                                        isPlaying={isPlaying}
                                        setIsPlaying={setIsPlaying}
                                        isMuted={isMuted}
                                        setIsMuted={setIsMuted}
                                        videoSource={popUpVideo}
                                    />
                                </Box>
                            </CustomModal>
                        )}
                    </>
                    : null}
        </>
    );
}

export default RiskwiseBanner;